export const routes = {
  FAQ: '/faq',
  ONBOARDING: '/',
  LIMITS: '/limits',
  SIGN_UP: '/sign-up',
  SIGN_IN: '/sign-in',
  PROFILE: '/profile',
  PAYMENTS: '/payments',
  CARD_MENU: '/card-menu',
  STATISTICS: '/statistics',
  NEW_PASSWORD: '/new-password',
  CARD_DETAILS: '/card-details',
  OPEN_DEPOSIT: '/open-deposit',
  IBAN_PAYMENT: '/iban-payment',
  INVOICE_SENT: '/invoice-sent',
  OPEN_NEW_CARD: '/open-new-card',
  OPEN_MONEYBOX: '/open-moneybox',
  OPEN_NEW_LOAN: '/open-new-loan',
  TAB_NAVIGATOR: '/tab-navigator',
  FUND_TRANSFER: '/fund-transfer',
  TOP_UP_PAYMENT: '/top-up-payment',
  PAYMENT_FAILED: '/payment-failed',
  MOBILE_PAYMENT: '/mobile-payment',
  CREATE_INVOICE: '/create-invoice',
  PRIVACY_POLICY: '/privacy-policy',
  FORGOT_PASSWORD: '/forgot-password',
  CHANGE_PIN_CODE: '/change-pin-code',
  PAYMENT_SUCCESS: '/payment-success',
  SELECT_LANGUAGE: '/select-language',
  CONFIRMATION_CODE: '/confirmation-code',
  EDIT_PERSONAL_INFO: '/edit-personal-info',
  TRANSACTION_DETAILS: '/transaction-details',
  SIGN_UP_ACCOUNT_CREATED: '/sign-up-account-created',
  VERIFY_YOUR_PHONE_NUMBER: '/verify-your-phone-number',
  FORGOT_PASSWORD_SENT_EMAIL: '/forgot-password-sent-email',
};

export const tabRoutes = {
  DASHBOARD: 'dashboard',
  LOANS: 'loans',
  DEPOSITS: 'deposits',
  NOTIFICATIONS: 'notification',
  MORE: 'more',
};
